import React from "react";
import { CLabel } from "@coreui/react";

import image from "assets/image/elcamino-black.png";
import "./styles.css";

function Header({ showFinish, text }) {
  return (
    <div className="header-principal">
      <img src={image} alt="Iglesia El Camino" className="elcamino" />
      {!showFinish && (
        <CLabel>
          <b>
            {text ||
              "BIENVENIDO AL PORTAL DE RESERVA DE ASIENTOS DE LA IGLESIA EL CAMINO"}
          </b>
        </CLabel>
      )}
    </div>
  );
}

export default Header;
